import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Banknote, TrendingUp, Home } from 'lucide-react';

export const WhyChooseUs: React.FC = () => {
  return (
    <section className="py-20 overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {/* Left Column - Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-8"
          >
            <div className="max-w-xl">
              <h2 className="mb-8 text-3xl font-bold md:text-4xl">
                Why should you use our services?
              </h2>
              <div className="space-y-8">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-blue-100 rounded-full">
                    <TrendingUp className="w-7 h-7 md:w-8 md:h-8 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Best Price Valuation</h3>
                    <p className="text-gray-600">
                      We value your vehicle at the best market price
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-blue-100 rounded-full">
                    <CheckCircle2 className="w-7 h-7 md:w-8 md:h-8 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">The Easiest Way to Sell</h3>
                    <p className="text-gray-600">
                      Enter your details and receive your vehicle valuation online, sell only if you want
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-blue-100 rounded-full">
                    <Banknote className="w-7 h-7 md:w-8 md:h-8 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Instant Payment</h3>
                    <p className="text-gray-600">
                      The vehicle is paid for with instant payment (Instant Bank Transfer)
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex-shrink-0 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-blue-100 rounded-full">
                    <Home className="w-7 h-7 md:w-8 md:h-8 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Home Collection</h3>
                    <p className="text-gray-600">
                      We collect your vehicle from your home at no cost
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Images */}
          <div className="relative">
            {/* Accent Image */}
            <motion.img
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              src="/img/accent1.png"
              alt="Accent"
              className="absolute right-0 z-10 w-32 -top-10"
            />
            
            {/* Main Images */}
            <div className="relative grid grid-cols-1 gap-4 md:grid-cols-2">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
                className="relative h-64 overflow-hidden rounded-lg"
              >
                <img
                  src="/img/why1.jpg"
                  alt="Why Choose Us"
                  className="object-cover w-full h-full transition-transform duration-300 hover:scale-110"
                />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4 }}
                className="relative h-64 overflow-hidden rounded-lg"
              >
                <img
                  src="/img/why2.jpg"
                  alt="Why Choose Us"
                  className="object-cover w-full h-full transition-transform duration-300 hover:scale-110"
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}; 